<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { isNaturalProfile } from '../../../utilities/investment-process/useUserProfileType'
import { usePersonalAccountDataState } from '../../../utilities/account/useAccountDataPersonal'
import { useLegalAccountDataState } from '../../../utilities/account/useAccountDataLegal'
import { ExclamationCircleIcon, CheckCircleIcon, MailIcon, CheckIcon, ChatAlt2Icon } from '@heroicons/vue/solid'
import { DocumentTextIcon, PrinterIcon } from '@heroicons/vue/outline'
import BaseButtonMuted from '../../base/BaseButtonMuted.vue'
import { MembershipDocumentPostStatus, MembershipDocumentStatus } from '../../../typings'
import { requestPhysicalMail } from '../../../utilities/api'
const accountStateNatural = usePersonalAccountDataState()
const accountStateLegal = useLegalAccountDataState()
const account = ref(null)

onMounted(async () => {
    if (isNaturalProfile()) {
        account.value = accountStateNatural.naturalProfile
    } else {
        account.value = accountStateLegal.legalProfile
    }
})
</script>

<template>
    <div v-if="account.certificates.length">
        <h3 class="flex px-6 py-4 pl-0 text-xl font-bold text-gray-900">
            <DocumentTextIcon class="mr-2 w-5" />
            {{ $t('membership_management.order_certificates') }}
        </h3>
        <div v-if="account">
            <div v-for="(cert, index) in account.certificates" :key="index">
                <a :href="cert.url" target="_blank">{{ cert.name }} ({{ cert.created }})</a>
            </div>
        </div>
    </div>
</template>
